export const ENV_IDENTIFIER = {
  LOCAL: 'local', //标识本地开发
  DEV: 'zjdev',
  TEST: 'zjst',
  OLD_PRE: 'zjpre',
  PRE: 'zjpre',
  PRODUCT: 'zjga',
};

export const IS_SERVER = typeof window === 'undefined';

// 环境变量不存在时，或者 ENV 的值就是 local
// ENV 在构建时会注入jenkins or 云效
export const IS_LOCAL = !process.env.ENV || process.env.ENV === 'local';
